<template>
  <div class="security-log-container">
    <div class="security-log-title">
      <div class="content_auto">
        <router-link to="/personal" class="security-log-btn">
          <span class="security-log-btn-icon">‹</span> {{ $t('安全记录') }}
        </router-link>
      </div>
    </div>
    <div class="security-log content_auto">
      <!-- 选项卡 - 开始 -->
      <table class="safety-log-table">
        <tr>
          <th>{{ $t('时间') }}</th>
          <th>{{ $t('安全设置') }}</th>
          <th>IP</th>
        </tr>
        <tr v-for="securityLog in securitySetArr" :key="securityLog.id">
          <td>{{ securityLog.date }}</td>
          <td>{{ securityLog.operateName }}</td>
          <td>{{ securityLog.ip }}</td>
        </tr>
      </table>

      <!-- 选项卡 - 结束 -->
    </div>

    <div class="page-wrap content_auto" v-if="securitySetArr.length">
      <Page
        size="small"
        class-name="page-con"
        :current.sync="page.current"
        :total="page.total"
        :page-size="7"
        @on-change="changePage"
      />
    </div>
    <NoData v-else height="200px" sceneType="day"></NoData>
  </div>
</template>

<script>
import { ajax_security_set_log } from '@/api/personal'

export default {
  name: 'SecurityLog',
  data() {
    return {
      securitySetArr: [],
      page: {
        // 分页信息对象
        start: 1,
        total: 0 // 数据总数
      }
    }
  },
  created() {
    this.getSecurityLog()
  },
  methods: {
    changePage(num) {
      // 切换分页
      this.page.start = num
      this.searchSecuritySetLog()
    },
    async getSecurityLog() {
      // 查询登录信息
      const { count, item } = await ajax_security_set_log({
        start: this.page.start,
        offset: 7
      })

      // 设置分页总数
      this.page.total = count
      // 设置列表
      this.loginRecordArr = item
    }
  }
}
</script>
<style lang="less" scoped>
.security-log-title {
  padding: 60px 0 30px;
  background: #131625;
}

.security-log {
  margin: 16px auto 80px;
}

.security-log-btn {
  font-size: 20px;
  font-weight: 400;
  color: #fff;
  text-decoration: none;
}

.security-log-btn-icon {
  font-size: 23px;
}

.safety-log-table {
  .table-base(@w: 100%, @h: auto, @lh: 58px);
}

.page-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 80px;
}

/deep/ .page-con {
  .page-base();
}
</style>
